import React from 'react';
import { Button } from 'reactstrap';

export const ListItem = ({ item, setItemToEdit }) => {
    const value = item?.choices?.hasOwnProperty(item.value) ? item.choices[item.value] : item.value;

    return (
        <tr>
            <td
                data-label="ID"
                className="alert-list-td"
            >
                {item.name}
            </td>
            <td
                data-label="Name"
                className="alert-list-td"
            >
                {value}
            </td>
            <td data-label="Actions">
                <div className="responsive-table__edit-block">
                    <Button
                        color="light"
                        onClick={() => setItemToEdit(item)}
                    >
                        <i className="fa fa-pencil fa-lg"/>
                    </Button>
                </div>
            </td>
        </tr>
    );
};
